'use client';

import { useIsAuthReady } from '@/hooks/profile/is-auth-ready';
import { ReactNode } from 'react';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner';

type AuthGuardComponentProps = {
  children: ReactNode;
};

export const AuthGuardComponent = ({ children }: AuthGuardComponentProps): React.JSX.Element | null => {
  const { isAuthenticated, isLoading } = useIsAuthReady();

  if (isLoading || !isAuthenticated) {
    return (
      <div className="container-md mx-auto">
        <LoadingSpinnerComponent className="!m-0" />
      </div>
    );
  }

  return <>{children}</>;
};
